import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "allowNegative", "numberOfDigits", "decimalScale", "placeholder", "value"];
import React from 'react';
import { FormattedInput } from '../FormattedInput/FormattedInput';

/**
 * InputPercent proactively eliminates errors by restricting and formatting data to align
 * with user expectations and business requirements.
 */
export var InputPercent = function InputPercent(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Percent' : _ref$label,
      _ref$allowNegative = _ref.allowNegative,
      allowNegative = _ref$allowNegative === void 0 ? false : _ref$allowNegative,
      _ref$numberOfDigits = _ref.numberOfDigits,
      numberOfDigits = _ref$numberOfDigits === void 0 ? 2 : _ref$numberOfDigits,
      _ref$decimalScale = _ref.decimalScale,
      decimalScale = _ref$decimalScale === void 0 ? 0 : _ref$decimalScale,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '%' : _ref$placeholder,
      value = _ref.value,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(FormattedInput, _extends({
    label: label,
    placeholder: placeholder
  }, otherProps, {
    allowNegative: allowNegative,
    numberOfDigits: numberOfDigits,
    decimalScale: decimalScale,
    suffix: "%",
    value: value // We force a smaller, fixed width to maintain consistency
    ,
    small: true // Used to restrict what's available
    // to mobile users via keyboard. We
    // don't use the pattern attribute
    // as that will trigger validation in some
    // browsers like Firefox.
    ,
    type: "tel" // Note: not all browser users will be able to
    // take advantage of inputMode yet -- until
    // then we should rely on the format prop
    // to safeguard the user from not getting
    // the decimal place on their mobile keyboard.
    // For example, format="##.##%" will insert
    // the decimal point by default
    ,
    inputMode: "decimal"
  }));
};